// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ea3b3890","249":"8ccd1eec","453":"2b9e5af2","554":"c311d820","667":"035fc3a8","914":"1281fbb0"}[chunkId] + ".chunk.js";
};